
/**
 * 对子域相关操作的帮助类
 */
let OpenContextUtil = {}

/**
 * 向子域推送图集信息
 * @return Promise
 */
OpenContextUtil.postSpFrame = function(plistName) {
    if (!window.mini || !mini.supportOpenContext())
        return;
    if (_G.__use_small_res)
        plistName = plistName.replace(/\.plist$/, "@6x.plist");
    let pngName = ResManager.getSameNamePng(plistName);

    let plistUrlItem = PackUrl(plistName);
    let pngUrlItem = PackUrl(pngName);

    let plistRealUrl = plistUrlItem.realUrl;
    let pngRealUrl = pngUrlItem.realUrl;

    return new Promise((resolve, reject)=> {
        let waitLoadedCount = 2;
        let hasLoadError = false;

        function onLoaded(err, res) {
            // 没网时候err = null, res.realUrl不变；
            // 下载出错时err 不为空， res = null
            waitLoadedCount--;

            if (err != null || res.realUrl == plistRealUrl || res.realUrl == pngRealUrl) {
                hasLoadError = true;
                console.error("fail in OpenContextUtil!", err,res.realUrl)
            }

            if (waitLoadedCount == 0) {
                if (hasLoadError) {
                    reject({ errMsg: `download or access file failed. plistName: ${plistName}; pngName: ${pngName}` })
                } else {
                    resolve();
                }
            }
        }

        wxDownloader.handle(plistUrlItem, onLoaded);
        wxDownloader.handle(pngUrlItem, onLoaded);
    }).then(()=> {
        // plist需要解析
        return new Promise((resolve, reject)=> {
            mini.getFileSystemManager().readFile({
                filePath: plistUrlItem.realUrl,
                encoding: 'utf8',
                success: resolve,
                fail: reject
            })
        });
    }).then(res=> {
        let plistContent = TryParseJSON(res.data)
        if (!plistContent)
            return Promise.reject({ errMsg: `failed to parse plist. plist: ${plistUrlItem.resUrl}, path: ${plistUrlItem.realUrl}` });
        
        let plistData = cc.spriteFrameCache._parseFrameConfig(plistContent);
        OpenContextUtil.postMessage({
            command: "update spframe",
            name: plistName,
            frames: plistData.frames,
            pngPath: pngUrlItem.realUrl,
            scale: 1 / cc.director.getContentScaleFactor()
        });
        
        return Promise.resolve();
    })
}

function TryParseJSON(content){
    try {
        return JSON.parse(content);
    }catch(e) {
        console.error("TryParseJSON in OpenContextUtil failed!", e, content);
        return null;
    }
}
/**
 * 处理资源路径
 * @param {string} fileName 
 */
function PackUrl(fileName) {
    let loader = cc.loader;
    let realUrl = loader.getUrl(loader.resPath, fileName);
    let type = cc.path.extname(fileName);
    let url = ResManager.getFileMd5(fileName);
    return {
        type,
        url,
        realUrl
    }
} 


let _lastCmd = null;
/**
 * 向子域发送命令
 */
OpenContextUtil.postMessage = function(obj) {
    if (!window.mini || !mini.supportOpenContext())
        return;
    if (obj && obj.command)
        _lastCmd = obj.command;
    mini.getOpenDataContext().postMessage(obj);
}

/**
 * 开放域是否活跃状态
 */
OpenContextUtil.isOpenContextActive = function() {
    if (!window.mini || !mini.supportOpenContext())
        return;
    return _lastCmd  && _lastCmd != "exit"
}

window.OpenContextUtil = OpenContextUtil;